import { create } from 'zustand'
import { isAuthenticated } from '@/lib/api'

interface AuthStore {
  authenticated: boolean
  setAuthenticated: (v: boolean) => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  authenticated: isAuthenticated(),
  setAuthenticated: (v: boolean) => set({ authenticated: v }),
}))
